module.exports = __webpack_public_path__ + "img/mobilePower.5ae9000a.jpg";